import { Col, Form, Input, Row } from 'antd';
import { FormComponentProps } from "antd/lib/form";
import React from 'react';

const FormItem = Form.Item;

interface IProps extends FormComponentProps {
    currentDay: number;
}

class BillingDateForm extends React.Component<IProps>{
    public render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="vertical">
                <Row gutter={48}>
                    <Col span={8}>
                        <FormItem label='Current Billing Date'>
                            {`${this.props.currentDay}`}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label={'New Billing Date'}>
                            {getFieldDecorator('newCycleDay', {
                                rules: [
                                    { validator: this.validateDay }
                                ],
                            })(<div><Input className="input" /></div>)}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }

    private validateDay = (rule: any, value: any, callback: any) => {
        // Validates that the input contains only numbers
        const regex = /^\d{1,2}$/g;
        if (!(value && value.toString().match(regex))){
            callback('Please enter valid amount')
        } else if (value < 1 || value > 31) {
            callback('Please enter valid amount')
        } else if (parseInt(value, 10) === this.props.currentDay) {
            callback('Day is the same as current billing day')
        } else {
            callback();
        }
    }
}

export default Form.create<IProps>()(BillingDateForm);
